import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { config } from '../../_models/attedenceStatus';
import { UtilityService } from '../../services/utility.service'
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component'


@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss']
})
export class ChangeStatusComponent implements OnInit {
  status = ['Present', 'Unauthorized Absence', 'Withdrawn', 'Authorized Absence', 'Unmark']
  finalStatus: any;
  attedenceStatus = config
  timeset = '00:00'
  edit: boolean = false
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _utilityService: UtilityService,
    public _change: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    console.log("this.data---->", this.data);
    if (this.data) {
      if (this.data.singleDay == 'AM') {
        this.timeset = this.data.attendanceAmHours
        this.finalStatus = this.data.amStatus
        if (!this.timeset) this.timeset = '00:00'

      }
      if (this.data.singleDay == 'PM') {
        this.timeset = this.data.attendancePmHours
        this.finalStatus = this.data.pmStatus
        if (!this.timeset) this.timeset = '00:00'

      }
    }
    this._change.detectChanges()
    console.log("this time set value here ==>", this.timeset)
  }

  statusChanged(event) {
    console.log(event);
    console.log("hello here is the event ===>", event)
    this.finalStatus = event.value
  }

  submit() {

    this.dialogRef.close({ status: this.finalStatus, time: this.timeset });
  }

  cancel() {
    console.log("data to be cancled", this.data);


    this.dialogRef.close();
  }

  setTime(value) {
    console.log("value while change time", value);
    this.timeset = value
  }
  closed() {
    // this.edit=false
  }

}
